import { useTranslation } from 'react-i18next';
import { PrivacyEn } from './legal/PrivacyEn';
import { PrivacyRu } from './legal/PrivacyRu';

/**
 * Public privacy policy (/privacy). The legal text lives as two whole documents
 * (legal/PrivacyRu.tsx is the original, legal/PrivacyEn.tsx its translation)
 * rather than as locale keys: it is long prose with inline links, and a
 * reviewer must be able to read each version start to finish.
 */
export function PrivacyPage() {
  const { i18n } = useTranslation();
  return i18n.language.startsWith('en') ? <PrivacyEn /> : <PrivacyRu />;
}
